module.exports = __webpack_public_path__ + "img/aya_nakamura-nouvelle_edition.aa9afcec.jpg";